export default {
    URL_API: "https://apisgt.rncloud.com.br/api",
    URL_API_REPORTS: "https://apirelatorios.rncloud.com.br/api"
}

